// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminEditPage_container__1AjrZ"};